import React, { useState } from "react";
import { GatsbyBrowser, Script } from "gatsby";
import BannerContext from "./src/contexts/bannerContext";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element }) => {
  const [isMounted, setIsMounted] = useState<boolean>(false);
  return <BannerContext.Provider value={{ isMounted, setIsMounted }}>{element}</BannerContext.Provider>;
};
